/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\OrderByStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Wednesday, February 15th 2023, 2:40:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

/**
* Styled component Button
*/
const OrderByStyled = styled.button.attrs((props: any) => ({
    bgColor: props.bgColor,
    border: props.border,
    borderHover: props.borderHover,
}))`
display: flex;
justify-content: space-evenly;
align-items: center;
width: 5rem;
background-color: #fff;
border-radius: 99px;
color: black !important;
font-weight: normal;
font-size: medium;
line-height: 1.5rem;
padding-right: 10px;
padding-left: 10px;
border: ${(props: any) => props.border}px solid ${(props: any) => getThemeColor(props.bgColor)};
&:hover{
    border: 4px solid ${(props: any) => getThemeColor(props.bgColor)};
}
`;

export default OrderByStyled;
